"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.screenLarge = exports.screenMedium = exports.screenSmall = void 0;
var screenSmall = 414;
exports.screenSmall = screenSmall;
var screenMedium = 768;
exports.screenMedium = screenMedium;
var screenLarge = 1024;
exports.screenLarge = screenLarge;